<template>
  <div>
    <NavHeaderBar :title="title" :onClickRight="onClickRight" rightArrow />
    <div class="showimg-dom">
      <div class="empty" v-if="url == ''">敬请期待</div>
      <img :src="url" v-if="url != ''" />
    </div>
  </div>
</template>
<script>
export default {
  name: "showImg",
  data: function () {
    return {
      url: "",
      title: "药大咖"
    };
  },
  mounted: function () {
    if (this.$route && this.$route.query.url) {
      this.url = this.$route.query.url;
      this.title = this.$route.query.title;
    }
  },
  methods: {
    onClickRight() {
      this.$router.push({
        path: "/conference",
        query: { code: this.$route.query.code }
      });
    }
  }
};
</script>
<style scoped>
.showimg-dom {
  width: 100%;
  padding-top: 40px;

}

.showimg-dom img {
  width: 100%;
}

.showimg-dom .empty {
  width: 100%;
  text-align: center;
  padding-top: 40px;
  font-size: 20px;
}
</style>
